export interface StarRatingInputProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
}

export function StarRatingInput({ value, onChange, max = 5 }: StarRatingInputProps) {
  return (
    <div className="site-support-star-rating" role="radiogroup" aria-label="Star rating">
      {Array.from({ length: max }, (_, index) => {
        const star = index + 1;
        const active = star <= value;
        return (
          <button
            key={star}
            type="button"
            className={`site-support-star-rating__star${active ? ' is-active' : ''}`}
            aria-checked={value === star}
            role="radio"
            title={`${star} star${star === 1 ? '' : 's'}`}
            onClick={() => onChange(star)}
          >
            ★
          </button>
        );
      })}
    </div>
  );
}
